// src/config/keycloak.js
import Keycloak from 'keycloak-js';

const keycloak = new Keycloak({
  url: import.meta.env.VITE_KEYCLOAK_URL || 'https://auth.laudea.in',
  realm: import.meta.env.VITE_KEYCLOAK_REALM || 'st-deploy',
  clientId: import.meta.env.VITE_KEYCLOAK_CLIENT_ID || 'deployment-system'
});

export default keycloak;